// export const COMPANY_TECH_TAGS_FETCH_DONE = 'COMPANY_TECH_TAGS_FETCH_DONE';
// export const COMPANY_TECH_TAGS_FETCH_START = 'COMPANY_TECH_TAGS_FETCH_START';
import { Map } from 'immutable';
import ImmutableMapInterface from '../ImmutableMapInterface.type';

export type CompanyTechTagsState = ImmutableMapInterface<CompanyTechTagsStateMap, string, any>;

export const COMPANY_TECH_TAGS_UPDATE = 'COMPANY_TECH_TAGS_UPDATE';

export const COMPANY_TECH_TAGS_MUTATE_START = 'COMPANY_TECH_TAGS_MUTATE_START';

export interface CompanyTechTagsStateMap extends Map<string, any> {
  companyTechTags: CompanyTechTag[];
}

export type CompanyTechTag = string;

export type CompanyTechTagsUpdatePayload = string[];

export interface CompanyTechTagsMutationPayload {
  profileId: number | null;
  tags: CompanyTechTagsUpdatePayload;
}

export interface CompanyTechTagsUpdateAction {
  type: typeof COMPANY_TECH_TAGS_UPDATE;
  payload: CompanyTechTagsUpdatePayload;
}

export interface CompanyTechTagsMutationAction {
  type: typeof COMPANY_TECH_TAGS_MUTATE_START;
  payload: CompanyTechTagsMutationPayload;
}